module.exports = __webpack_public_path__ + "static/media/poster15.bcdd0a0c.png";